var React = require("react");
var $ = require('jquery');
var Reflux = require('reflux');
var slugify = require('../helpers/slugify');
var _ = require('underscore');

// Actions
var JobActions = require('../actions/job_actions');

// Stores
var LanguageStore = require('../stores/language_store');
var JobStore = require('../stores/job_store');

// Job Area
module.exports = React.createClass({

	// Render
  	render: function(){
  		
  		var manuallyFillUrl = '/'+this.props.env+'/apply/'+this.props.job.job_id+'/'+slugify(this.props.job.title);
  		
  		if(typeof this.props.env_info.custom_job_board_domain != 'undefined' && this.props.env_info.custom_job_board_domain != ''){
  			var custom_domain = this.props.env_info.custom_job_board_domain;
  			//var url_title = (job.url_title != '') ? job.url_title : slugify(job.title);
  			
  			
	  		manuallyFillUrl = 'http://'+custom_domain+'/apply/'+this.props.job.job_id+'/'+slugify(this.props.job.title);
  		}
  		
  		manuallyFillUrl += '?w=callback';
  		
   		return (
   			<a href={manuallyFillUrl} className="callback-button">
  				<span className="fa fa-phone"></span> {this.props.job.custom_callback_button}
  			</a>
	  	);
	}
});
